import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "https://vfsrhukexmsdwezzalll.supabase.co";
const supabasePublicKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
  || "sb_publishable_SVpBcujgAtRij2vaS0wjwQ_TGHOD1ig";

export const supabase = createClient(supabaseUrl, supabasePublicKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Email confirmation links can be opened in a different tab or browser
    // context, so they must not depend on a locally stored PKCE verifier.
    flowType: "implicit",
  },
});
